export default class ApiCommunicationError extends Error {
  /**
   * Create ApiCommunicationError
   * @param {String} message
   */
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    Error.captureStackTrace(this, this.constructor);
  }
}
